
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SavePortfolioDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  portfolioName: string;
  onPortfolioNameChange: (name: string) => void;
  onSave: () => void;
}

export const SavePortfolioDialog = ({
  isOpen,
  onOpenChange,
  portfolioName,
  onPortfolioNameChange,
  onSave,
}: SavePortfolioDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Save Portfolio</DialogTitle>
          <DialogDescription>
            Enter a name for your portfolio to save your current allocation and settings.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="portfolio-name" className="font-medium">Portfolio Name</Label>
            <Input
              id="portfolio-name"
              placeholder="Enter portfolio name"
              value={portfolioName}
              onChange={(e) => onPortfolioNameChange(e.target.value)}
              className="min-h-[44px]"
            />
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto min-h-[44px]"
          >
            Cancel
          </Button>
          <Button onClick={onSave} className="w-full sm:w-auto min-h-[44px]">
            Create Portfolio
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
